<template>
    <div v-if="!showMediaFlag" class="mx-auto mt-[-55px] z-0 flex justify-between">
        <div class="w-[40%]">
            <div><b class="text-[#BD9135]">Тип елемента:</b> <span class="text-[#fff]">{{element.name}}</span></div>
            <div><b class="text-[#BD9135]">Назва вправи:</b> <span class="text-[#fff]">{{parseElementType(element.type)}}</span></div>
            <div><b class="text-[#BD9135]">Блок елемента:</b> <span class="text-[#fff]">{{parseAgeGroup(element.training_program_years)}}</span></div>
            <div class="mt-[50px] text-[#BD9135] flex items-center">
                <b class="mr-[3px]">Час виконання (хв.):</b>
                <input :value="element.time" @change="e => $emit('changeTime', e.target.value)" class="bg-[#1b1b1b] outline-none text-white text-[14px] w-[150px] py-[5px] px-[5px] rounded-[6px]" placeholder="Введіть час">
            </div>
            <div v-if="element.type !== 'standard'" class="mt-[20px] grid grid-cols-1 gap-3 w-[260px]">
                <div class="text-[#BD9135]">
                    <div class="mb-[6px] font-semibold">Кількість гравців</div>
                    <input
                        v-model="element.players_number"
                        type="number"
                        class="bg-[#1b1b1b] outline-none text-white text-[14px] w-full py-[5px] px-[8px] rounded-[6px] border border-[#474849]"
                        placeholder="0"
                        min="0"
                    >
                </div>
                <div class="text-[#BD9135]">
                    <div class="mb-[6px] font-semibold">Кількість підходів</div>
                    <input
                        v-model="element.approaches_number"
                        type="number"
                        class="bg-[#1b1b1b] outline-none text-white text-[14px] w-full py-[5px] px-[8px] rounded-[6px] border border-[#474849]"
                        placeholder="0"
                        min="0"
                    >
                </div>
                <div class="text-[#BD9135]">
                    <div class="mb-[6px] font-semibold">Час підходу (хв.)</div>
                    <input
                        v-model="element.approach_time"
                        type="number"
                        class="bg-[#1b1b1b] outline-none text-white text-[14px] w-full py-[5px] px-[8px] rounded-[6px] border border-[#474849]"
                        placeholder="0"
                        min="0"
                        step="0.1"
                    >
                </div>
                <div class="text-[#BD9135]">
                    <div class="mb-[6px] font-semibold">Розмір майданчику (м.)</div>
                    <div class="flex items-center gap-2">
                        <input
                            v-model="element.field_width"
                            type="number"
                            class="bg-[#1b1b1b] outline-none text-white text-[14px] w-full py-[5px] px-[8px] rounded-[6px] border border-[#474849]"
                            placeholder="0"
                            min="0"
                            step="0.1"
                        >
                        <span class="text-white text-[14px]">×</span>
                        <input
                            v-model="element.field_height"
                            type="number"
                            class="bg-[#1b1b1b] outline-none text-white text-[14px] w-full py-[5px] px-[8px] rounded-[6px] border border-[#474849]"
                            placeholder="0"
                            min="0"
                            step="0.1"
                        >
                    </div>
                </div>
                <div class="text-[#BD9135]">
                    <div class="mb-[6px] font-semibold">Відпочинок між підходами (хв.)</div>
                    <input
                        v-model="element.approaches_break"
                        type="number"
                        class="bg-[#1b1b1b] outline-none text-white text-[14px] w-full py-[5px] px-[8px] rounded-[6px] border border-[#474849]"
                        placeholder="0"
                        min="0"
                        step="0.1"
                    >
                </div>
            </div>
            <div class="mt-[50px] text-[#BD9135]"><b>Опис елементу:</b></div>
            <div class="text-[#fff]">
                {{element.info}}
            </div>
        </div>
        <div class="w-[40%]">
            <div v-if="element.additional_images.length > 0">
                <div class="font-bold text-[#BD9135]">Ілюстрації</div>
                <div class="flex mt-[15px]">
                    <!-- <img v-for="picture in element.additional_images" class="mr-[10px] cursor-pointer" :src="apiURL + 'static/' + picture" /> -->

                    <carousel v-if="element.additional_images.length" :per-page="1">
                        <slide v-for="picture in element.additional_images" :key="schema">
                            <img class="mr-[10px] cursor-pointer w-[250px]" :src="apiURL + 'static/' + picture" />
                        </slide>
                    </carousel>
                </div>
            </div>
            <div v-if="element.schemas.length > 0" class="mt-[35px]">
                <div class="font-bold text-[#BD9135]">Схеми</div>
                <div class="flex mt-[15px]">
                    <!-- <img v-for="schema in element.schemas" class="mr-[10px] cursor-pointer" src="@/desktopApp/assets/icons/picture_icon.svg" /> -->
                    <carousel v-if="element.schemas.length" :per-page="1">
                        <slide v-for="schema in element.schemas" :key="schema">
                            <img class="mr-[10px] cursor-pointer w-[250px]" :src="apiURL + 'static/' + schema" />
                        </slide>
                    </carousel>
                </div>
            </div>
            <div v-if="element.additional_videos.length > 0" class="mt-[35px]">
                <div class="font-bold text-[#BD9135]">Відео</div>
                <div class="flex mt-[15px]">
                    <!-- <img v-for="video in element.additional_videos" @click="() => {videoToShow = video; showMediaFlag = true}" class="mr-[10px] cursor-pointer" src="@/desktopApp/assets/icons/video_icon.svg" /> -->
                    <div>
                        <YouTube 
                            v-for="video in element.additional_videos"
                            :src="video" 
                            :key="video"
                            class="w-full"
                            ref="youtube" 
                        />                
                    </div>
                
                
                </div>
            </div>
        </div>
    </div>

    <div v-if="showMediaFlag" class="w-full flex flex-col items-center justify-center">
        <YouTube 
            v-if="videoToShow"
            :src="videoToShow" 
            class="w-full"
            ref="youtube" 
        />
        <div @click="() => {showMediaFlag = false; videoToShow = ''}" class="bg-[#BD9135] text-[#252526] cursor-pointer mt-[20px] border-[1px] text-center border-[#BD9135] text-[18px] w-[20%] py-[3px] px-[5px] rounded-[6px]">Назад</div>
        
    </div>

    <div v-if="!showMediaFlag" class="w-[100%] flex flex-col items-center justify-center mt-[50px]">
        <div @click="$emit('back')" class="bg-[#BD9135] text-[#252526] cursor-pointer mt-[20px] border-[1px] text-center border-[#BD9135] text-[18px] w-[20%] py-[3px] px-[5px] rounded-[6px]">Назад</div>
        <div v-if="canDelete" @click="$emit('deleteElement', element)" class="bg-[#DA4167] text-[#252526] cursor-pointer mt-[20px] border-[1px] text-center border-[#DA4167] text-[18px] w-[20%] py-[3px] px-[5px] rounded-[6px]">Видалити елемент</div>
    </div>
</template>

<script>
    import { ref } from "vue";
    import YouTube from 'vue3-youtube';
    import 'vue3-carousel/dist/carousel.css'
    import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

    export default {
        name: "ElementView",

        props: {
            element: {
                type: Object,
                default: () => {}
            },
            canDelete: {
                type: Boolean,
                default: true
            }
        },

        setup() {
            const videoToShow = ref('')
            const showMediaFlag = ref(false)
            const apiURL = process.env.VUE_APP_API_URL

            const parseElementType = (type) => {
                switch (type) {
                    case 'standard':
                        return 'Норматив'
                    case 'exercise':
                        return 'Вправа'
                    case 'task':
                        return 'Завдання'
                    default:
                        return 'Невідомий тип елементу'
                }
            }

            const parseAgeGroup = (ageGroup) => {
                switch (ageGroup) {
                    case '6_years':
                        return 'Невідомий блок'
                    case '7_years':
                        return 'Невідомий блок'
                    case '8_years':
                        return 'Невідомий блок'
                    case '9_years':
                        return 'Невідомий блок'
                    case '10_years':
                        return 'Невідомий блок'
                    case '11_years':
                        return 'Невідомий блок'
                    case '12_years':
                        return 'Невідомий блок'
                    case '13_years':
                        return 'Невідомий блок'
                    case '14_years':
                        return 'Невідомий блок'
                    case '15_years':
                        return 'Невідомий блок'
                    case '16_years':
                        return 'Невідомий блок'
                    case '17_years':
                        return 'Невідомий блок'
                    case '18_years':
                        return 'Невідомий блок'
                    case '19_years':
                        return 'Невідомий блок'
                    case '20_years':
                        return 'Невідомий блок'
                    case '21_years':
                        return 'Невідомий блок'
                    case '22_years':
                        return 'Невідомий блок'
                    case '23_years':
                        return 'Невідомий блок'
                    case 'main_team':
                        return 'Невідомий блок'
                    default:
                        return ageGroup
                }
            }

            const parseScoring = (scoring) => {
                switch (scoring) {
                    case 'time':
                        return 'Час'
                    case 'point':
                        return 'Оцінка'
                    case 'length':
                        return 'Відстань'
                    default:
                        return '-'
                }
            }

            return {
                parseElementType,
                parseAgeGroup,
                parseScoring,
                videoToShow,
                showMediaFlag,
                apiURL
            }
        },

        components: {
            YouTube,
            Carousel,
            Slide
        }
    }
</script>

<style lang="scss" scoped>

</style>